import type { ComponentProps } from "react";
import { CTA_URL } from "../constants/cta";
import { trackRegisterClick } from "../utils/analytics";

type RegisterLinkProps = ComponentProps<"a"> & {
  trackLabel?: string;
};

export default function RegisterLink({
  href = CTA_URL,
  trackLabel,
  onClick,
  target = "_blank",
  rel = "noopener noreferrer",
  children,
  ...props
}: RegisterLinkProps) {
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      onClick={(e) => {
        trackRegisterClick(trackLabel);
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </a>
  );
}
